export const GET_WORKORDER_ITEMS = "GET_WORKORDER_ITEMS"
export const GET_WORKORDER_ITEMS_SUCCESS = "GET_WORKORDER_ITEMS_SUCCESS"
export const GET_WORKORDER_ITEMS_FAIL = "GET_WORKORDER_ITEMS_FAIL"

export const ADD_WORKORDER_ITEM = "ADD_WORKORDER_ITEM"
export const ADD_WORKORDER_ITEM_SUCCESS = "ADD_WORKORDER_ITEM_SUCCESS"
export const ADD_WORKORDER_ITEM_FAIL = "ADD_WORKORDER_ITEM_FAIL"

export const UPDATE_WORKORDER_ITEM = "UPDATE_WORKORDER_ITEM"
export const UPDATE_WORKORDER_ITEM_SUCCESS = "UPDATE_WORKORDER_ITEM_SUCCESS"
export const UPDATE_WORKORDER_ITEM_FAIL = "UPDATE_WORKORDER_ITEM_FAIL"

export const DELETE_WORKORDER_ITEM = "DELETE_WORKORDER_ITEM"
export const DELETE_WORKORDER_ITEM_SUCCESS = "DELETE_WORKORDER_ITEM_SUCCESS"
export const DELETE_WORKORDER_ITEM_FAIL = "DELETE_WORKORDER_ITEM_FAIL"

export const SET_WORKORDER_ITEM_FIELD_ERRORS = "SET_WORKORDER_ITEM_FIELD_ERRORS"
